/**
 * Persist rehydration uses `dateAwareDataDeserializer` (QueryClientProvider.tsx), which can turn
 * ISO-like strings into Date objects. Normalize before string ops / rendering.
 */
export function persistedValueToString(value: unknown, maxLen?: number): string {
  let s: string;
  if (value == null) s = '';
  else if (value instanceof Date) s = value.toISOString();
  else if (typeof value === 'string') s = value;
  else s = String(value);
  return maxLen !== undefined ? s.slice(0, maxLen) : s;
}
